"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../../types");
const secondEmail = '';
exports.testOktaProfile = {
    userId: 'testOktaId',
    firstName: 'TestFirstName',
    lastName: 'TestLastName',
    mobilePhone: '07123456789',
    customerGroup: 'testCustomerGroup',
    secondEmail,
    memberStatus: types_1.MembershipTypes.MembershipState.ACTIVE,
    memberType: 'Regular Member',
    Roles: ['testRole'],
    login: 'TestFirstname.TestLastName@test.com',
    email: 'TestFirstname.TestLastName@test.com',
    AICPAUID: 'testAicpaId',
    ClientAdminOf: ['testOrgSalesforceId'],
    FirmBillingClientAdminOf: ['testOrgSalesforceId'],
    CentersClientAdminOf: ['testOrgSalesforceId'],
    TuitionProviderClientAdminOf: ['testOrgSalesforceId'],
    siebelRegistered: false,
    employeeNumber: 'testSalesforceId',
    zuora: 'CURRENCY;a:test|c:test',
};
exports.testOktaUser = {
    id: 'testOktaId',
    status: 'ACTIVE',
    created: 'testDate',
    activated: 'testDate',
    statusChanged: 'testDate',
    lastLogin: 'testDate',
    lastUpdated: 'testDate',
    passwordChanged: 'testDate',
    profile: exports.testOktaProfile,
    type: {
        id: 'testOktaProfileId',
    },
    credentials: {
        password: {},
        recovery_question: {
            question: 'Test recovery question?',
        },
        provider: {
            type: 'OKTA',
            name: 'OKTA',
        },
    },
    _links: {
        self: {
            href: 'Test link to view user in Okta',
        },
    },
};
//# sourceMappingURL=index.js.map